import { flow, set } from 'lodash/fp';

import { ArkDocument, ArkTableDocument } from './types';
import { NettingEngineSummary } from '../../opinions/store/types';

export const updateNettingAnalysis = (document: ArkDocument | ArkTableDocument, nettingCanBeCalculated: number, nettingSummary: NettingEngineSummary) => flow(
    set('nettingIsCalculating', 0),
    set('nettingCanBeCalculated', nettingCanBeCalculated),
    set('nettingSummary', nettingSummary)
)(document);
